interface RetryAssetDownloadOptions {
  maxAttempts?: number;
  delay?: number;
}

const sleep = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });

export const importWithRetry = async <T>(
  promiseFactory: () => Promise<T>,
  { maxAttempts = 3, delay = 500 }: RetryAssetDownloadOptions = {},
): Promise<T> => {
  let result: T | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let error: any;
  let success = false;

  let attempt = 1;
  while (!success && attempt <= maxAttempts) {
    // If this is a retry, we want to wait for the delay before
    // issuing another request
    if (attempt > 1) {
      await sleep(delay);
    }

    try {
      result = await promiseFactory();
      success = true;
    } catch (e) {
      error = e;
      attempt++;
    }
  }

  if (success) {
    return result as T;
  } else {
    throw error;
  }
};
